namespace GeniuzPOS.AdvPromo {
    export interface PsPromoAvShopRow {
        Id?: number;
        PmGroupId?: string;
        ShopId?: string;
    }

    export namespace PsPromoAvShopRow {
        export const idProperty = 'Id';
        export const nameProperty = 'PmGroupId';
        export const localTextPrefix = 'AdvPromo.PsPromoAvShop';
        export const lookupKey = 'AdvPromo.PsPromoAvShop';

        export function getLookup(): Q.Lookup<PsPromoAvShopRow> {
            return Q.getLookup<PsPromoAvShopRow>('AdvPromo.PsPromoAvShop');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            PmGroupId = "PmGroupId",
            ShopId = "ShopId"
        }
    }
}
